import { memo, useCallback } from 'react';

import { useDateCascade } from 'app/pages/loanApplication/tabs/loanClosingCDS/EditDrawer/Content/hooks/useDateCascade';
import { SECTION_HREF_MAP } from 'app/pages/loanApplication/tabs/loanClosingCDS/EditDrawer/EditDrawer.config';
import PropTypes from 'prop-types';

import { CLOSING_FORM_PATH } from '../../LoanEditorCustomFormDrawer.constants';

const ClosingDateCascade = ({
  closingFormValues,
  setInForm,
  hasInterestCredit,
  loanApplication,
  isChattel,
  setCurrentCloseAt,
  setCurrentNoteDate,
  setCurrentFundingDate,
  businessDays = null,
  subjectPropertyOccupancy = null,
  subjectPropertyState = null,
  maturityTermMonths = null,
}) => {
  const setInClosingForm = useCallback(
    (fieldName, value, isInitiatedByUser) =>
      setInForm(`${CLOSING_FORM_PATH}.${fieldName}`, value, isInitiatedByUser),
    [setInForm],
  );

  const cascadeParams = {
    form: closingFormValues,
    setInForm: setInClosingForm,
    hasInterestCredit,
    businessDays,
    loanApplication,
    subjectPropertyOccupancy,
    subjectPropertyState,
    setCurrentCloseAt,
    setCurrentNoteDate,
    setCurrentFundingDate,
    maturityTermMonths,
    isChattel,
  };

  useDateCascade({ ...cascadeParams, currentSection: SECTION_HREF_MAP.SCHEDULING });
  useDateCascade({ ...cascadeParams, currentSection: SECTION_HREF_MAP.CLOSING_FUNDING_DATES });

  return null;
};

ClosingDateCascade.propTypes = {
  closingFormValues: PropTypes.object.isRequired,
  setInForm: PropTypes.func.isRequired,
  hasInterestCredit: PropTypes.bool.isRequired,
  loanApplication: PropTypes.object.isRequired,
  isChattel: PropTypes.bool.isRequired,
  setCurrentCloseAt: PropTypes.func.isRequired,
  setCurrentNoteDate: PropTypes.func.isRequired,
  setCurrentFundingDate: PropTypes.func.isRequired,
  businessDays: PropTypes.object,
  subjectPropertyOccupancy: PropTypes.string,
  subjectPropertyState: PropTypes.string,
  maturityTermMonths: PropTypes.number,
};

export default memo(ClosingDateCascade);
